export enum FeatureFlag {
	Printing = 'printing',
	DashMessage = 'dashMessage',
	AccountScreenServices = 'accountScreenServices',
	AzureMaps = 'azureMaps',
	RedirectUrl = 'redirectUrl',
	PortalVersionCheck = 'portalVersionCheck'
}
